import React, { useEffect, useMemo, useState } from 'react';
import Api from '../../../Api';
import MyLoading from '../../../components/MyLoading';
import { fetchTemplatePhotos } from '../../../helpers/organizationsBulkAutofill';

const ALL_SUB_CATEGORIES = '';

/**
 * Выбор шаблонных фото по категории/подкатегории (те же папки, что на экране «Шаблонные фото»).
 */
function TemplatePhotosPicker({
  value = [],
  onChange,
  categories = [],
  initialCategoryId = '',
  initialSubCategoryId = '',
  lockedCategoryId = '',
  lockedSubCategoryId = '',
}) {
  const [categoryId, setCategoryId] = useState(lockedCategoryId || initialCategoryId);
  const [subCategoryId, setSubCategoryId] = useState(lockedSubCategoryId || initialSubCategoryId);
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const category = useMemo(
    () => categories.find((item) => item._id === categoryId) || null,
    [categories, categoryId],
  );

  useEffect(() => {
    let cancelled = false;
    if (!categoryId) {
      setPhotos([]);
      return undefined;
    }
    setError('');
    setLoading(true);
    fetchTemplatePhotos({ categoryId, subCategoryId: subCategoryId || undefined })
      .then((list) => {
        if (!cancelled) setPhotos(list);
      })
      .catch(() => {
        if (!cancelled) {
          setPhotos([]);
          setError('Не удалось загрузить шаблонные фото.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [categoryId, subCategoryId]);

  const togglePhoto = (photo) => {
    if (value.includes(photo._id)) {
      onChange(value.filter((id) => id !== photo._id));
    } else {
      onChange([...value, photo._id]);
    }
  };

  const selectAllInFolder = () => {
    const ids = photos.map((photo) => photo._id).filter((id) => !value.includes(id));
    onChange([...value, ...ids]);
  };

  return (
    <div className="bulk_offers_photos_picker">
      <div className="bulk_offers_field_inline">
        <select
          className="bulk_offers_select"
          value={categoryId}
          onChange={(e) => {
            setCategoryId(e.target.value);
            setSubCategoryId(ALL_SUB_CATEGORIES);
          }}
          disabled={Boolean(lockedCategoryId)}
        >
          <option value="">— Категория фото —</option>
          {categories.map((item) => (
            <option key={item._id} value={item._id}>
              {`${item.name}${item.is_online ? ' — онлайн' : ''}`}
            </option>
          ))}
        </select>
        <select
          className="bulk_offers_select"
          value={subCategoryId}
          onChange={(e) => setSubCategoryId(e.target.value)}
          disabled={!category?.sub_categories?.length || Boolean(lockedSubCategoryId)}
        >
          <option value={ALL_SUB_CATEGORIES}>Все подкатегории</option>
          {(category?.sub_categories || []).map((item) => (
            <option key={item._id} value={item._id}>{item.name}</option>
          ))}
        </select>
      </div>

      <div className="bulk_offers_photos_picker_head">
        <p className="bulk_offers_field_note">
          {`Выбрано фото: ${value.length}`}
        </p>
        <div className="bulk_offers_photos_picker_actions">
          <span
            className={`bulk_offers_link ${!photos.length ? 'disabled' : ''}`}
            onClick={photos.length ? selectAllInFolder : undefined}
          >
            Выбрать все в папке
          </span>
          <span
            className={`bulk_offers_link ${!value.length ? 'disabled' : ''}`}
            onClick={value.length ? () => onChange([]) : undefined}
          >
            Снять выбор
          </span>
        </div>
      </div>

      {error ? <p className="bulk_offers_error">{error}</p> : null}

      {loading ? (
        <MyLoading />
      ) : !categoryId ? (
        <p className="bulk_offers_field_note">Выберите категорию, чтобы увидеть её шаблонные фото.</p>
      ) : !photos.length ? (
        <p className="bulk_offers_field_note">В этой папке нет шаблонных фото.</p>
      ) : (
        <div className="bulk_offers_photos_grid">
          {photos.map((photo) => (
            <div
              key={photo._id}
              className={`bulk_offers_photos_grid_item ${value.includes(photo._id) ? 'selected' : ''}`}
              onClick={() => togglePhoto(photo)}
            >
              <img src={`${Api.url}${photo.photo?.preview_url || ''}`} alt="" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TemplatePhotosPicker;
